import { FC, useCallback, useState, useMemo } from 'react'
import { AdvisorRequestPanePreset } from 'components/features/coaching/advisorMeeting/AdvisorRequestPanePreset/AdvisorRequestPanePreset'
import { AdvisorMeetingWizardFields } from 'components/features/coaching/advisorMeeting/types/requests'
import { useStoreDispatch, useStoreSelector } from 'helpers/reactReduxHelpers'
import { SubscribeAndCreateMeetingAction } from 'components/features/coaching/advisorStore/actions/advisorMeetingActions'
import { modifyFloatingPaneActionCreator } from 'actions/floatingPanesActions'
import Button from 'components/features/pfm/Button/Button'
import { SubscriptionPanel, PlanOption } from 'components/features/premium/SubscriptionPanel/SubscriptionPanel'
import { SubscriptionMessageOverlay } from 'components/features/pfm/SubscriptionMessageOverlay/SubscriptionMessageOverlay'
import { MONTHLY_SUBSCRIPTION_FEE, YEARLY_SUBSCRIPTION_FEE } from 'constants/subscription'

type AdvisorRequestSubscriptionProps = {
  fields: AdvisorMeetingWizardFields
  onClose: () => void
}
export const AdvisorRequestSubscription: FC<AdvisorRequestSubscriptionProps> = (props) => {
  const { onClose, fields } = props
  const isLoading = useStoreSelector((state) => state.data.subscription.stripeCreatePaymentMethod.isLoading)
  const [isStripeReady, setIsStripeReady] = useState(false)
  const [plan, setPlan] = useState<PlanOption>('monthly')

  const handlePlanChange = useCallback((nextPlan) => {
    setPlan(nextPlan)
  }, [])
  const dispatch = useStoreDispatch()

  const handleBack = useCallback(() => {
    dispatch(modifyFloatingPaneActionCreator('advisor', { mode: 'request', step: 'confirm', fields }))
  }, [fields, dispatch])


  const handleConfirm = useCallback(() => {
    const amount = plan === 'annual' ? YEARLY_SUBSCRIPTION_FEE : MONTHLY_SUBSCRIPTION_FEE
    dispatch(new SubscribeAndCreateMeetingAction({
      amount,
      fields,
    }))
  }, [fields, dispatch, plan])

  const handleStripeReady = useCallback(() => {
    setIsStripeReady(true)
  }, [])

  const secondaryButton = (
    <Button text='Back' style='hollow' qaMarker='back' fullWidth onClick={ handleBack } />
  )

  const messageChild = useMemo(() => (
    <SubscriptionMessageOverlay />
  ), [])

  return (
    <AdvisorRequestPanePreset
      title='Schedule a New Coaching Session'
      subTitle={ fields.flow === 'regular' ? '4. Upgrade to Premium' : 'Make your payment' }
      actionName='FINISH'
      progressBarPercent={ 90 }
      onSuccess={ handleConfirm }
      onCancel={ onClose }
      isLoading={ isLoading }
      actionDisabled={ isLoading || !isStripeReady }
      secondaryButton={ secondaryButton }
      notification={ messageChild }
    >
      <SubscriptionPanel
        value={ plan }
        onChange={ handlePlanChange }
        onClose={ onClose }
        onStripeReady={ handleStripeReady }
      />
    </AdvisorRequestPanePreset>
  )
}

